export enum TipoModulo {
	Arrecadacao = '1',
	ConcessaoBeneficio = '3',
	FolhaBeneficio = '4',
	Emprestimo = '9',
	Contabil = '12',
	Atuarial = '14',
}
